import { __assign } from '../../../../../_externals/.pnpm/tslib@2.7.0/node_modules/tslib/tslib.es6.js';
import * as React from 'react';
import * as Typography from '../../../atoms/Typography/Typography.js';
import Button from '../../../atoms/Button/Button.js';
import { Container, Content, Footer } from './ExpandedCookieForm.styles.js';
import PreferenceItem from './PreferenceItem/PreferenceItem.js';

var ExpandedCookieForm = function (_a) {
    var title = _a.title, savePreferencesBtnText = _a.savePreferencesBtnText, onSavePreferences = _a.onSavePreferences, preferences = _a.preferences, checkboxActiveLabel = _a.checkboxActiveLabel, checkboxInactiveLabel = _a.checkboxInactiveLabel, checkboxAlwaysActiveLabel = _a.checkboxAlwaysActiveLabel;
    var _b = React.useState(preferences.reduce(function (curr, preference) {
        curr[preference.id] = preference.active;
        return curr;
    }, {})), preferencesActiveState = _b[0], setPreferencesActiveState = _b[1];
    var getCheckboxLabel = function (preference) {
        if (preference.alwaysActive)
            return checkboxAlwaysActiveLabel;
        var currentPreferenceActive = preferencesActiveState[preference.id];
        return currentPreferenceActive
            ? checkboxActiveLabel
            : checkboxInactiveLabel;
    };
    return (React.createElement(Container, { "data-testid": "ExpandedCookieForm" },
        React.createElement("header", null,
            React.createElement(Typography.Heading, { as: "h2" }, title)),
        React.createElement(Content, null, preferences.map(function (preference) {
            var label = preference.label, description = preference.description, alwaysActive = preference.alwaysActive;
            return (React.createElement(PreferenceItem, { key: label, label: label, description: description, checkboxLabel: getCheckboxLabel(preference), checked: preferencesActiveState[preference.id], onChange: function () {
                    setPreferencesActiveState(function (prevPreferencesActiveState) {
                        var _a;
                        return (__assign(__assign({}, prevPreferencesActiveState), (_a = {}, _a[preference.id] = !prevPreferencesActiveState[preference.id], _a)));
                    });
                }, alwaysActive: alwaysActive }));
        })),
        React.createElement(Footer, null,
            React.createElement(Button, { onClick: function () {
                    onSavePreferences(preferencesActiveState);
                }, variant: "primary" }, savePreferencesBtnText))));
};

export { ExpandedCookieForm as default };
//# sourceMappingURL=ExpandedCookieForm.js.map
